class NSSComparisonTable extends HTMLElement {

  constructor() {
    super();
    this.debug = false;
    this.swiper = null;
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Comparison Table] Connected.`);
    this.addEventListener(`click`, this.handleClick.bind(this));
    // Defer so slides are in the DOM and measurable
    requestAnimationFrame(() => this.initSwiper());
    // Re-init swiper when a parent nss-buybox-bottom becomes visible
    const bottomEl = this.closest(`nss-buybox-bottom`);
    if (bottomEl) {
      this._visibilityObserver = new MutationObserver(() => {
        if (bottomEl.classList.contains(`nss-active`)) {
          requestAnimationFrame(() => {
            if (this.swiper) {
              this.swiper.update();
            } else {
              this.initSwiper();
            }
          });
        }
      });
      this._visibilityObserver.observe(bottomEl, { attributes: true, attributeFilter: [`class`] });
    }
  }

  disconnectedCallback() {
    if (this._visibilityObserver) {
      this._visibilityObserver.disconnect();
      this._visibilityObserver = null;
    }
  }

  initSwiper() {
    const swiperEl = this.querySelector(`.nss-comparison-table__swiper`);
    if (!swiperEl || typeof Swiper === `undefined`) return;

    const paginationEl = this.querySelector(`.nss-comparison-table__pagination`);

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      uniqueNavElements: false,
      observer: true,
      observeParents: true,
      effect: `fade`,
      fadeEffect: { crossFade: true },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        990: {
          enabled: false,
        }
      },
      on: {
        slideChange: () => this.syncSelectorToSwiper(),
      }
    });
  }

  syncSelectorToSwiper() {
    if (!this.swiper) return;
    const activeSlide = this.swiper.slides[this.swiper.activeIndex];
    if (!activeSlide) return;

    const id = activeSlide.getAttribute(`nss-column-id`);
    // Slide markup differs between blocks: the column title span may be
    // `.nss-subtitle-s4` or `.nss-body` inside the head cell — read either.
    const headCell = activeSlide.querySelector(`.nss-row-head-0`);
    const label = headCell?.querySelector(`.nss-subtitle-s4, span`)?.textContent?.trim() || ``;

    // Update label text (guard against empty so we never blank a valid label)
    const selectedEl = this.querySelector(`[nss-selected-column]`);
    if (selectedEl && label) selectedEl.textContent = label;

    // Update icon
    const iconContainer = this.querySelector(`[nss-selected-column-icon]`);
    if (iconContainer) {
      const slideIcon = activeSlide.querySelector(`.nss-comparison-table__cell-image`);
      iconContainer.innerHTML = slideIcon ? slideIcon.innerHTML : ``;
    }

    // Update dropdown buttons
    this.querySelectorAll(`button[nss-column-id]`).forEach(btn => btn.classList.remove(`nss-active`));
    this.querySelector(`button[nss-column-id="${id}"]`)?.classList.add(`nss-active`);
  }

  handleClick(e) {
    if (this.debug) console.log(`[NSS][Comparison Table] Clicked!`);

    // Use closest() so clicks on child elements (icons, spans) still register
    const toggleBtn = e.target.closest(`[nss-selected-column-btn]`);
    if (toggleBtn) {
      toggleBtn.parentElement.classList.toggle(`nss-active`);
    }

    const colBtn = e.target.closest(`button[nss-column-id]`);
    if (colBtn) {
      const id = colBtn.getAttribute(`nss-column-id`);

      if (this.swiper) {
        const slides = this.swiper.slides;
        for (let i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute(`nss-column-id`) === id) {
            this.swiper.slideTo(i);
            break;
          }
        }
      }

      this.querySelector(`.nss-comparison-table__button-selected`)?.parentElement.classList.remove(`nss-active`);
    }
  }
}

let elementName = `nss-comparison-table`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSComparisonTable);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
